$(function() {
    $(".plantilla_list_view .btnConfirmDelete").click(function () {
        var btn = $(this);
        $.post('/api/plantilla/'+$(this).closest('li').data('id_reg_plantilla')+'/delete', {}, function (response) {
            if (response.status=='fail'){
                $(btn).closest('.alert').html(response.data.msg);
            }else{
                $(btn).closest('li').remove();
            }
        });
    });

    $(".plantilla_list_view .btnConfirmDuplicate, .plantilla_list_view .btnConfirmDuplicateCopiar").click(function () {
        var btn = $(this);
        var id = btn.closest('li').data('id_reg_plantilla');
        var copiar = btn.hasClass('btnConfirmDuplicateCopiar') ? '?copiar=1' : '';

        $.post('/api/plantilla/' + id + '/duplicate' + copiar, {}, function (response) {
            if (response.status === 'fail') {
                btn.closest('.alert').html(response.data.msg);
            } else {
                window.location.reload();
            }
        });
    });

});